import "core-js/modules/web.dom.iterable";
import defaultSettings from '@/settings';
var showSettings = defaultSettings.showSettings,
  fixedHeader = defaultSettings.fixedHeader,
  sidebarLogo = defaultSettings.sidebarLogo;
var state = {
  showSettings: showSettings,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  cancelTokenArr: [],
  // 储存cancel token
  loading: false // 加载提示
};
var mutations = {
  CHANGE_SETTING: function CHANGE_SETTING(state, _ref) {
    var key = _ref.key,
      value = _ref.value;
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  },
  PUSH_CANCEL: function PUSH_CANCEL(state, payload) {
    state.cancelTokenArr.push(payload.cancelToken);
  },
  CLAER_CANCEL: function CLAER_CANCEL(_ref2) {
    var cancelTokenArr = _ref2.cancelTokenArr;
    cancelTokenArr.forEach(function (item) {
      item('取消请求');
    });
    cancelTokenArr = [];
  },
  SET_LOADING: function SET_LOADING(state, data) {
    state.loading = data;
  }
};
var actions = {
  changeSetting: function changeSetting(_ref3, data) {
    var commit = _ref3.commit;
    commit('CHANGE_SETTING', data);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};